/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { useT } from 'talkr';
import steps from '../../../survey/steps';
import questions from '../../../survey/questions';
import info from '../index.module.scss';
import common from '../../index.module.scss';
import s from './index.module.scss';
import female from './img/female.svg';
import male from './img/male.svg';

const imgs = {
	female,
	male
};

function Caffeine () {
	const { T } = useT();
	const gender = questions.getAnswers({ questionName: 'gender' }).value;

	useEffect(() => {
		steps.setStepStatus({
			stepName: 'caffeine',
			stepStatus: true
		});
	}, []);

	return (
		<div className={common.step}>
			<h1 className={common.stepTitle}>
				{T('caffeine_title')}
			</h1>
			<img className={s.img} src={imgs[gender]} alt="Cup of coffee" />
			<div className={info.description}>
				<h2 className={info.subTitle}>{T('caffeine_description')}</h2>
				<p className={info.text} dangerouslySetInnerHTML={{ __html: T('caffeine_paragraph_1') }} />
				<p className={info.text} dangerouslySetInnerHTML={{ __html: T('caffeine_paragraph_2') }} />
				<p className={info.text} dangerouslySetInnerHTML={{ __html: T('caffeine_paragraph_3') }} />
			</div>
		</div>
	);
}

export default Caffeine;
